import parser, { Element } from "html-react-parser";
import React from "react";
import { CloseButton } from "~/components/acquisition-popup-container/display/popups/common/close-button";
import { PopupBackdrop } from "~/components/acquisition-popup-container/display/styles";
import { useSdkContext } from "~/components/contexts";
import { Modal } from "~/components/modal";
import CheckedIcon from "./checked.svg";
import { Container, ContentContainer, Description, DownloadLink, StyledRedirectButton, Title } from "./styles";
export const MyNewsCompletionPopup = ({
  config,
  modalContainerReference,
  onClose
}) => {
  const {
    currentRoute
  } = useSdkContext();
  const isMyNewsIndexPage = currentRoute.toLowerCase() === "mynews";
  const computedButtonText = () => isMyNewsIndexPage ? config.button.inMyNewsText : config.button.otherPageText;
  return /*#__PURE__*/React.createElement(Modal, {
    BackdropComponent: PopupBackdrop,
    container: modalContainerReference === null || modalContainerReference === void 0 ? void 0 : modalContainerReference.current,
    fadeTimeout: 400,
    open: true,
    "data-qa": "my-news-completion-popup"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(CloseButton, {
    onClose: () => {
      onClose();
    }
  }), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(CheckedIcon, null), /*#__PURE__*/React.createElement(Title, {
    dangerouslySetInnerHTML: {
      __html: config.headline
    }
  }), /*#__PURE__*/React.createElement(Description, null, parser(config.description, {
    replace: domNode => {
      if (domNode instanceof Element && domNode.name === "download-link") {
        return /*#__PURE__*/React.createElement(DownloadLink, {
          onClick: () => {
            window.open("https://scmp.onelink.me/3586748601/aalocqf2", "_blank");
          }
        }, "download");
      }
      return domNode;
    }
  })), /*#__PURE__*/React.createElement(StyledRedirectButton, {
    dangerouslySetInnerHTML: {
      __html: computedButtonText()
    },
    url: "/mynews",
    onClick: () => {
      onClose();
    }
  }))));
};
MyNewsCompletionPopup.displayName = "MyNewsCompletionPopup";